import { TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from '../../common/components/LocalizationProvider';

export const filterByKeyword = (keyword) => (item) =>
  !keyword || JSON.stringify(item).toLowerCase().includes(keyword.toLowerCase());

const useStyles = makeStyles()((theme) => ({
  header: {
    position: 'sticky',
    top: 0,              // importante para sticky funcionar bem
    left: 0,
    zIndex: 2,           // evita ficar atrás da tabela
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: theme.spacing(3, 2, 2),
    background: theme.palette.background.paper, // evita “transparente” em cima da tabela
  },
}));

const SearchHeader = ({ keyword, setKeyword }) => {
  const { classes } = useStyles();
  const t = useTranslation();

  // ? Agora aparece em qualquer tamanho de tela
  return (
    <div className={classes.header}>
      <TextField
        variant="outlined"
        placeholder={t('sharedSearch') || 'Pesquisar...'}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        fullWidth
        size="small"
      />
    </div>
  );
};

export default SearchHeader;
